import store from 'store2';

import config from 'config';
import { isFormData, isJsonContentType, JSON_CONTENT_TYPE } from '@mssgme/api-client';
import { ACCESS_TOKEN_KEY } from './constants';

const IMAGE_VARIANT = 'normal';
const ICON_VARIANT = 'icon_192';

export class Media {
    constructor(baseUrl) {
        this.baseUrl = baseUrl;
    }

    async listFiles(filters) {
        return this.makeGet('/files', filters);
    }

    async uploadFile({ file, workspace, website, destination }) {
        const form = new FormData();
        form.append('file', file);
        form.append('workspace', workspace);
        form.append('website', website);
        form.append('destination', destination);
        return this.makePost('/api/files', form);
    }

    async uploadImage({ file, workspace, website, destination }) {
        const form = new FormData();
        form.append('file', file);
        form.append('variant', IMAGE_VARIANT);
        form.append('workspace', workspace);
        if (website) form.append('website', website);
        form.append('destination', destination);
        return this.makePost('/api/images', form);
    }

    async uploadIcon({ file, workspace, website, destination }) {
        const form = new FormData();
        form.append('file', file);
        form.append('variant', ICON_VARIANT);
        form.append('format', 'png');
        form.append('workspace', workspace);
        form.append('website', website);
        form.append('destination', destination);
        return this.makePost('/api/images', form);
    }

    // example payload: { path: ['/images/photo1.jpg', '/images/photo2.jpg'] }
    deleteFiles(payload) {
        return this.makePost('/api/files/delete', payload);
    }

    getHeaders() {
        return {
            Accept: JSON_CONTENT_TYPE,
            Authorization: `Bearer ${this.getAccessToken()}`,
        };
    }

    getAccessToken() {
        return store.get(ACCESS_TOKEN_KEY);
    }

    async makePost(endpoint, payload) {
        const urlObj = new URL(endpoint, this.baseUrl);
        const isForm = isFormData(payload);
        const headers = this.getHeaders();

        if (!isForm) {
            headers['Content-Type'] = JSON_CONTENT_TYPE;
        }

        const response = await fetch(urlObj, {
            method: 'POST',
            body: isForm ? payload : JSON.stringify(payload),
            headers,
        });
        if (response.status === 204) return;

        return isJsonContentType(response.headers) ? response.json() : response.text();
    }

    async makeGet(endpoint, filters) {
        const urlObj = new URL(endpoint, this.baseUrl);
        urlObj.search = new URLSearchParams(filters);
        const response = await fetch(urlObj, { headers: this.getHeaders() });

        return isJsonContentType(response.headers) ? response.json() : response.text();
    }
}

export default new Media(config.media_url);
